// Import your Web Components (assuming they are in components/)
import '../../components/index.ts'; // Imports all components from index.js
import { initializeRouter } from './router-init.js';

// Wait for components to be defined before initializing router
Promise.all([
  customElements.whenDefined('dashboard-page'),
  customElements.whenDefined('zoom-gears-page'),
  customElements.whenDefined('navigation-sidebar'),
  customElements.whenDefined('ui-library-demo')
]).then(() => {
  initializeRouter();
  // Show the main content once router is ready
  setTimeout(() => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.style.opacity = '1';
    }
  }, 100);
});

document.addEventListener("DOMContentLoaded", () => {
    setThemeMode();
    
    // Show loading state initially
    const routerOutlet = document.querySelector('ewc-router-outlet');
    if (routerOutlet && !routerOutlet.shadowRoot) {
      const loadingHTML = `
        <div class="loading-container">
          <div class="loading-spinner"></div>
        </div>
      `;
      routerOutlet.innerHTML = loadingHTML;
    }
    
    setTimeout(() => {
      document.body.classList.remove("hidden");
    }, 100);
    
    // Handle sidebar toggle events
    document.addEventListener('sidebar-toggled', (event) => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        if (event.detail.isCollapsed) {
          mainContent.style.marginLeft = '60px';
        } else {
          mainContent.style.marginLeft = '250px';
        }
      }
    });
    
    // Set initial margin for main content
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.style.marginLeft = '250px'; // Default expanded state
    }
  });
  
  const themeChanged = (isDark) => {
  const themeEvent = new CustomEvent('theme-changed', { 
    detail: {
      theme: { 
        switchFrom: isDark ? "" : "dark",
        switchTo: isDark ? "dark" : "" 
        }
      } 
    });
  window.dispatchEvent(themeEvent);
  }
  
  const setThemeMode = () => {
  const isDark = (localStorage.getItem("darkMode") === "true");
  if (isDark) {
    document.documentElement.classList.add("dark");
    themeChanged(isDark);
  }
  const button = document.getElementById("darkMode");
  if (button) button.textContent = isDark ? "☀" : "🌙";
  }
  
  const toggleDarkMode = () => {
  document.documentElement.classList.toggle("dark");
  
  setTimeout(() => {
    const isDark = document.documentElement.classList.contains("dark");
    localStorage.setItem("darkMode", isDark);
    themeChanged(isDark);
   
    const button = document.getElementById("darkMode");
    if (button) button.textContent = isDark ? "☀" : "🌙";
  }, 1);
  }
  
  window.toggleDarkMode = toggleDarkMode;